import { svg } from "lit";
const icon = svg `<path d="M9.45842 4.41602V13.501L5.19077 9.23333L4.41675 9.99933L10.0001 15.5826L15.5834 9.99933L14.8094 9.23333L10.5417 13.501V4.41602H9.45842Z" fill="currentColor"/>`;
export default icon;
